<template>
  <section id="services" class="services">
    <div class="container">
      <h1>What We Do</h1>
      <div class="service-offering">
        <div class="service-offering__wrap">
          <p class="service-offering__heading">
            Strategy & Planning
          </p>
          <p class="service-offering__descriptions">
            Focused and goal driven strategies to make the most of your budget. Content planning, Brand management, branding and your CI, we will ensure that you stand out from the crowd and remain relevant in the market. We will assist you with the planning, negotiating, implementation and maintenance of Strategic Partnership development as well as Sales Funnels / journeys.
          </p>
        </div>
        <div class="service-offering__wrap">
          <p class="service-offering__heading">
            Digital & Social Media Marketing
          </p>
          <p class="service-offering__descriptions">
            No, having a Facebook page and website is not enough. Let us assist in taking your online presence to the next level using website design, UX, Social media, Google ads, just to name a few - the fundi's will find what's right for you.
          </p>
        </div>
        <div class="service-offering__wrap">
          <p class="service-offering__heading">
            Public Relations & Communication
          </p>
          <p class="service-offering__descriptions">
            Reputation management, Crisis PR, content creation, product launches, media events, copywriting, newsletters and more. There is no need to hire a Communications Manager or PRO, we have you covered.
          </p>
        </div>
        <div class="service-offering__wrap">
          <p class="service-offering__heading">
            Project & Event Management
          </p>
          <p class="service-offering__descriptions">
            Let's make sure your project is on track. From conceptualization, planning, logistics, sponsorships and implementation we are there to ensure smooth sailing and to handle the storms. Like with all event teams, we have Disaster managers for those days.
          </p>
        </div>
        <div class="service-offering__wrap">
          <p class="service-offering__heading">
            Relationship Marketing
          </p>
          <p class="service-offering__descriptions">
            We are CRM experts, direct communication (SMS's & newsletters), data collection and hygiene strategies, Consumer behaviour and Rewards programmes, customer / sales analytics - let us assist you with the best solution for your business.
          </p>
        </div>
        <div class="service-offering__wrap">
          <p class="service-offering__heading">
            Additional services
          </p>
          <p class="service-offering__descriptions">
            Mystery Shopping, Customer Service training, Customer Service strategy & implementation, Advertising plans (ATL & BTL), Advert bookings, Radio scripts, Promotional items – whatever you need we can provide.
          </p>
        </div>
      </div>
      <marking />
    </div>
    <floral-background />
  </section>
</template>

<script>
// Components
import Marking from './components/marking'
import Floralbackground from './components/floral-background'
export default {
  components: {
    Marking,
    'floral-background': Floralbackground
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/styles/_variables';
@import "../../assets/styles/breakpoints";
  .services {
    margin: 50px 0;
    position: relative;
    @include breakpoint(sm) {
      margin: 25px 0;
    }
    .logo-marking {
      width: 40px;
      height: 40px;
    }
    .background-floral {
      position: absolute;
      width: 400px;
      right: -150px;
      top: 50%;
      z-index: -10;
      @include breakpoint(sm) {
        width: 300px;
        top: 50%;
      }
    }
    .container {
      position: relative;
      margin-bottom: 200px;

      h1 {
        position: relative;
        display: inline-block;
        font-size: 50px;
        line-height: 50px;
        color: $indigo;
        bottom: -50px;
        left: 50%;
        transform: translateX(-50%);
        font-family: 'Autography', Courier, monospace;
        @include breakpoint(sm) {
          font-size: 40px;
          left: 0;
          transform: translateX(0);
        }
      }
      &:after {
        display: block;
        position: absolute;
        z-index: -10;
        top: 0;
        width: 100vw;
        height: 75px;
        content: '';
        background: $accent-block;
        @include breakpoint(sm) {
          left: 0;
        }
      }
      .service-offering {
        margin-top: 100px;
        display: grid;
        // grid-template-columns: 50% 50%;
        grid-template-rows: 1fr 1fr;
        gap: 50px 50px;
        grid-template-areas: ". ." ". .";
        @include breakpoint(sm) {
          grid-template-rows: 1fr;
          gap: 30px;
          grid-template-areas: ".";
        }
        .service-offering__wrap {
          .service-offering__heading {
            position: relative;
            padding-left: 30px;
            &:before {
              position: absolute;
              height: 3px;
              width: 20px;
              background-color: $gold;
              top: 50%;
              left: 0;
              content: '';
              transform: translateY(-50%)
            }
          }
          .service-offering__descriptions {
            font-weight: 200;
            text-align: justify;
          }
        }
      }
      .logo-marking {
        position: relative;
        left: 50%;
        transform: translateX(-50%);
        top: 100px;
      }
    }
  }
</style>
